"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountTray = void 0;
exports.default = AccountTrayWrapper;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _componentUtilities = require("@ux/component-utilities");
var _trayMenu = require("@ux/tray-menu");
var _enums = require("../enums");
var _reactMintl = require("@godaddy/react-mintl");
var _userDetails = _interopRequireDefault(require("./user-details"));
var _signIn = _interopRequireDefault(require("./sign-in"));
var _createAccount = _interopRequireDefault(require("./create-account"));
var _quickLinks = _interopRequireDefault(require("./quick-links"));
var _userCircle = _interopRequireDefault(require("@ux/icon/user-circle"));
var _headerUtil = require("@ux/header-util");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/* jscs:disable requireSpacesInsideJsxExpressionContainers */

/**
 * Render and expose the AccountTray as a functional Component.
 *
 * @param {Object} props Properties
 * @returns {ReactElement} Namespaced AccountTray.
 * @api public
 */
class AccountTray extends _react.Component {
  /**
   * generates custom sso links for login and create account
   * @returns {Object} sso links
   */
  getSsoLinks() {
    var _window, _window$location;
    const {
      sso,
      urls
    } = this.props;
    let loginLink = urls.sso.login.href;
    let createAccountLink = urls.sso.createAccount.href;
    let path = '/';
    if (sso !== null && sso !== void 0 && sso.path) {
      path = sso.path;
    } else if (typeof window !== 'undefined' && (_window = window) !== null && _window !== void 0 && (_window$location = _window.location) !== null && _window$location !== void 0 && _window$location.pathname) {
      path = window.location.pathname;
    }
    loginLink = _headerUtil.url.updateQuery(loginLink, {
      path
    });
    createAccountLink = _headerUtil.url.updateQuery(createAccountLink, {
      path
    });
    return {
      createAccountLink,
      loginLink
    };
  }
  render() {
    const props = this.props;
    let name;
    if (!(0, _componentUtilities.isMobile)(props.breakpoint)) {
      if (props.loggedIn) {
        // props.displayName is the short name (e.g. "Jane").
        name = props.displayName;
      } else {
        name = /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
          id: _enums.golf.login
        });
      }
    }
    const trayName = /*#__PURE__*/_react.default.createElement("span", {
      className: "account-tray-name"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "user-icon"
    }, /*#__PURE__*/_react.default.createElement(_userCircle.default, null)), /*#__PURE__*/_react.default.createElement("span", {
      className: "title-text"
    }, name));
    const ssoLinks = this.getSsoLinks();
    return /*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
      locale: props.market,
      messages: props.messages
    }, /*#__PURE__*/_react.default.createElement(_trayMenu.TrayMenu, {
      type: "base",
      className: (0, _classnames.default)('account-tray', {
        'is-pro': props.loggedIn && props.isPro
      }),
      name: trayName,
      "data-eid": "uxp.hyd.shared.utility_bar.account_tray.click"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "tray-content-flex"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "tray-content-user"
    }, /*#__PURE__*/_react.default.createElement(_userDetails.default, props), !props.loggedIn && /*#__PURE__*/_react.default.createElement("div", {
      className: "content-wrap content-wrap-logged-out"
    }, /*#__PURE__*/_react.default.createElement(_signIn.default, (0, _extends2.default)({}, props, ssoLinks)), /*#__PURE__*/_react.default.createElement(_createAccount.default, (0, _extends2.default)({}, props, ssoLinks)))), /*#__PURE__*/_react.default.createElement(_quickLinks.default, props))));
  }
}

/**
 * Default properties for account tray.
 *
 * @type {Object}
 * @api public
 */
exports.AccountTray = AccountTray;
AccountTray.defaultProps = {
  urls: {
    products: 'https://mya.godaddy.com',
    renewals: 'https://account.godaddy.com/billing?filter=expires&subFilter=90',
    account: 'https://account.godaddy.com',
    pro: 'https://pro.godaddy.com',
    manageDomains: 'https://dcc.godaddy.com',
    manageHosting: 'https://gateway.godaddy.com',
    sso: {
      o365Login: 'https://sso.godaddy.com',
      webmailLogin: 'https://email.godaddy.com',
      login: 'https://sso.godaddy.com?realm=idp&app=mya&path=',
      logout: 'https://sso.godaddy.com/logout?realm=idp',
      createAccount: 'https://sso.godaddy.com/account/create?realm=idp&app=www&path='
    }
  },
  market: 'en-US',
  loggedIn: false,
  isPro: false,
  privateLabelId: 1
};

/**
 * Require properties.
 *
 * @type {Object}
 * @api public
 */
AccountTray.propTypes = {
  oldBrand: _propTypes.default.bool,
  sso: _propTypes.default.object,
  urls: _propTypes.default.object.isRequired,
  loggedIn: _propTypes.default.bool,
  privateLabelId: _propTypes.default.number,
  name: _propTypes.default.string,
  displayName: _propTypes.default.string,
  shopperId: _propTypes.default.string,
  isPro: _propTypes.default.bool,
  market: _propTypes.default.string.isRequired,
  messages: _propTypes.default.object.isRequired,
  vip: _propTypes.default.object,
  breakpoint: _propTypes.default.string.isRequired
};
function AccountTrayWrapper(props) {
  const {
    breakpoint
  } = (0, _componentUtilities.useBreakpoints)(..._enums.breakpoints);
  return /*#__PURE__*/_react.default.createElement(AccountTray, (0, _extends2.default)({
    breakpoint: breakpoint
  }, props));
}